/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTemplateMappingsRequestInner
 */
export interface UpdateTemplateMappingsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateMappingsRequestInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateMappingsRequestInner
     */
    templateField?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTemplateMappingsRequestInner
     */
    templateFieldList?: Array<string>;
}

/**
 * Check if a given object implements the UpdateTemplateMappingsRequestInner interface.
 */
export function instanceOfUpdateTemplateMappingsRequestInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateTemplateMappingsRequestInnerFromJSON(json: any): UpdateTemplateMappingsRequestInner {
    return UpdateTemplateMappingsRequestInnerFromJSONTyped(json, false);
}

export function UpdateTemplateMappingsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTemplateMappingsRequestInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'templateField': !exists(json, 'templateField') ? undefined : json['templateField'],
        'templateFieldList': !exists(json, 'templateFieldList') ? undefined : json['templateFieldList'],
    };
}

export function UpdateTemplateMappingsRequestInnerToJSON(value?: UpdateTemplateMappingsRequestInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'templateField': value.templateField,
        'templateFieldList': value.templateFieldList,
    };
}

